/**
 * supabaseClient.js — Cliente único de Supabase para el frontend.
 * Reemplaza la configuración de Clerk.
 *
 * Env (Vercel): VITE_SUPABASE_URL, VITE_SUPABASE_ANON_KEY, VITE_USE_SUPABASE
 */
import { createClient } from '@supabase/supabase-js'

const AUTH_LINK_TYPE_KEY = 'cd-auth-link-type'

/**
 * Tipo del link de auth con que se cargó la app (hash #...&type=invite|recovery).
 * Se captura ANTES de crear el cliente porque detectSessionInUrl consume y
 * limpia el hash. Lo usa SupabaseSessionSync para mandar al usuario invitado
 * a /establecer-password en su primer ingreso.
 */
export let initialAuthLinkType = (() => {
  try {
    const hash = window.location.hash || ''
    const m = hash.match(/[#&]type=(invite|recovery|signup)/)
    const type = m ? m[1] : null
    if (type === 'invite' || type === 'recovery') {
      sessionStorage.setItem(AUTH_LINK_TYPE_KEY, type)
    }
    return type
  } catch {
    return null
  }
})()

export function getPendingAuthLinkType() {
  if (initialAuthLinkType === 'invite' || initialAuthLinkType === 'recovery') {
    return initialAuthLinkType
  }
  try {
    const type = sessionStorage.getItem(AUTH_LINK_TYPE_KEY)
    return type === 'invite' || type === 'recovery' ? type : null
  } catch {
    return null
  }
}

export function clearPendingAuthLinkType() {
  initialAuthLinkType = null
  try { sessionStorage.removeItem(AUTH_LINK_TYPE_KEY) } catch { /* storage disabled */ }
}

export const isAuthEnabled = () =>
  import.meta.env.VITE_USE_SUPABASE === 'true' &&
  Boolean(import.meta.env.VITE_SUPABASE_URL) &&
  Boolean(import.meta.env.VITE_SUPABASE_ANON_KEY)

export const supabase = isAuthEnabled()
  ? createClient(import.meta.env.VITE_SUPABASE_URL, import.meta.env.VITE_SUPABASE_ANON_KEY, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true, // necesario para el callback de OAuth/recovery
      },
    })
  : null
